import React from 'react';
import styled from 'styled-components';
import { theme } from '../../theme';
import { CrossIcon } from '../../assets';

const Button = styled.button`
  align-items: center;
  background-color: ${theme.colors.primary.white};
  border: none;
  border-radius: 100%;
  box-shadow: 0 2px 4px 0 ${theme.colors.neutrals.solidGrays[6]};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
`;

const Cross = styled(CrossIcon)`
  fill: ${theme.colors.primary.graysGray};
  width: 10px;
`;

type CloseButtonProps = {
  onClick: () => void;
};

export const CloseButton: React.FC<CloseButtonProps> = ({ onClick }) => (
  <Button onClick={onClick}>
    <Cross />
  </Button>
);
